/* React */
import React from "react";

const FeatureSelection: React.FC = () => {
  return <div></div>;
};

export default FeatureSelection;
